// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/finalize_lightmap.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'finalize_lightmapPixelShader';
const shader = `#ifdef GL_ES
precision highp float;
#endif
varying vec2 vUV;
uniform sampler2D textureSampler;
uniform float final_frame;
uniform float dilation_enable;
uniform vec2 texel_size;
float unpack(vec4 color)
{
const vec4 bit_shift = vec4(1.0 / (255.0 * 255.0 * 255.0), 1.0 / (255.0 * 255.0), 1.0 / 255.0, 1.0);
return dot(color, bit_shift);
}
vec4 texel(vec2 uv) {
vec4 color = texture2D(textureSampler, uv);
return vec4(color.rgb * color.a, color.a);
}
float triangleNoise(const vec2 n) {
vec2 p = fract(n * vec2(5.3987, 5.4421));
p += dot(p.yx, p.xy + vec2(21.5351, 14.3137));
float xy = p.x * p.y;
float noise = (fract(xy * 95.4307) + fract(xy * 75.04961) - 1.0);
return noise;
}
#define RGB_TRIANGLE_NOISE 1
vec4 Dither_TriangleNoise(vec4 rgba) {
#if RGB_TRIANGLE_NOISE == 1
vec3 noise = vec3(
triangleNoise(vUV         ) / (255.0),
triangleNoise(vUV + 0.1337) / (255.0),
triangleNoise(vUV + 0.3141) / (255.0)
);
#else
vec3 noise = vec3(triangleNoise(vUV) / (255.0));
#endif
return vec4(rgba.rgb + noise, rgba.a);
}
void main(void)
{
vec4 color = vec4(0.0);
if(final_frame > 0.0) {
color = texel(vUV);
} else {
color = texture2D(textureSampler, vUV);
}
if (dilation_enable > 0.0 && color.a < 0.5) {
color = vec4(0.0, 0.0, 0.0, 0.0);
vec2 ts = texel_size;
color += texel(vUV + vec2( ts.x,  0.0));
color += texel(vUV + vec2(-ts.x,  0.0));
color += texel(vUV + vec2 (0.0,   ts.y));
color += texel(vUV + vec2( 0.0,  -ts.y));
color += texel(vUV + vec2(-ts.x, -ts.y));
color += texel(vUV + vec2( ts.x, -ts.y));
color += texel(vUV + vec2(-ts.x,  ts.y));
color += texel(vUV + vec2( ts.x,  ts.y));
#if 1
color += texel(vUV + vec2(-2.0 * ts.x, -2.0 * ts.y));
color += texel(vUV + vec2( 2.0 * ts.x, -2.0 * ts.y));
color += texel(vUV + vec2(-2.0 * ts.x,  2.0 * ts.y));
color += texel(vUV + vec2( 2.0 * ts.x,  2.0 * ts.y));
color += texel(vUV + vec2(-2.0 * ts.x,  -ts.y));
color += texel(vUV + vec2( 2.0 * ts.x,  -ts.y));
color += texel(vUV + vec2(-2.0 * ts.x,  0.0));
color += texel(vUV + vec2( 2.0 * ts.x,  0.0));
color += texel(vUV + vec2(-2.0 * ts.x,  ts.y));
color += texel(vUV + vec2( 2.0 * ts.x,  ts.y));
color += texel(vUV + vec2(-ts.x, -2.0 * ts.y));
color += texel(vUV + vec2(-ts.x,  2.0 * ts.y));
color += texel(vUV + vec2( 0.0,  -2.0 * ts.y));
color += texel(vUV + vec2( 0.0,   2.0 * ts.y));
color += texel(vUV + vec2(ts.x,  -2.0 * ts.y));
color += texel(vUV + vec2(ts.x,   2.0 * ts.y));
#endif
if (color.a > 0.5) {
color.rgb /= color.a;
color.a = 1.0;
} else {
color = vec4(0.5, 0.5, 0.5, 0.0);
if (final_frame > 0.0) {
color = vec4(0.5, 0.5, 0.5, 1.0);
}
}
}
if (final_frame > 0.0) {
color = Dither_TriangleNoise(color);
}
gl_FragColor = color;
}`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const finalize_lightmapPixelShader = { name, shader };
//# sourceMappingURL=finalize_lightmap.fragment.js.map